import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { selectPluginIdByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { variablePlugins } from '@ff-scene-plugins/gift-shared/registry';

const _VariableInputControlSlot = ({
    pluginId, variableIds,
    render
}: Props) => {

    const { InputControl } = variablePlugins.require(pluginId);

    if (!InputControl) {
        return null;
    }

    return render
        ? render(() => <InputControl variableIds={variableIds} />)
        : <InputControl variableIds={variableIds} />;
};

type Props = OwnProps & { pluginId: string };

type OwnProps = {
    render?: (Control: () => ReactElement) => ReactElement;
    variableIds: string[];
};

const mapStateToProps = (state: GiftPdpState, ownProps: OwnProps) => ({
    pluginId: selectPluginIdByVariableId(state, ownProps.variableIds[0])!
});

export const VariableInputControlSlot = connect(
    mapStateToProps
)(_VariableInputControlSlot);